import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, APP_INITIALIZER, LOCALE_ID } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { StepsModule } from 'primeng/steps';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { LayoutService } from './core/services/layout.service';
import { CommonModule } from './common/common.module';
import { SharedModule } from './shared/shared.module';
import { OAuthModule } from 'angular-oauth2-oidc';
import { RouterModule } from '@angular/router';
import { AuthService } from './core/services/auth.service';
import { TokenInterceptor } from './core/interceptor/token-interceptor';
import { InterceptorMessageService } from './core/interceptor/interceptor.message.service';
import { MessageService } from 'primeng/api';
import { StoreService } from './core/store/ngrx-store.service';
import { RootReducer } from './core/store/ngrx-store.reducer';
import { StoreModule } from '@ngrx/store';
import { DialogModule } from 'primeng/dialog';
import { AuthGuardMessageService } from './core/guards/auth-guard.message.service';
import { AppConfigService } from './core/app-config/app-config-service';

const initConfig = (authService: AuthService) => {
  return () => {
    return authService.login();
  };
};

const rxjsServices = [TokenInterceptor, InterceptorMessageService];

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    RouterModule,
    StoreModule.forRoot({ state: RootReducer }, {
      runtimeChecks: {
        strictStateImmutability: false,
        strictActionImmutability: false,
        strictStateSerializability: false,
        strictActionSerializability: false,
        strictActionWithinNgZone: true,
        strictActionTypeUniqueness: true,
      }
    }),
    OAuthModule.forRoot(),
    StepsModule,
    BreadcrumbModule,
    CommonModule,
    SharedModule,
    DialogModule
  ],
  providers: [
    LayoutService,
    StoreService,
    AuthGuardMessageService,
    AuthService,
    { provide: APP_INITIALIZER, useFactory: initConfig, deps: [AuthService], multi: true },
    { provide: LOCALE_ID, useValue: 'en' },
    MessageService,
    ...rxjsServices,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    AppConfigService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
